<template>
   <collapse-item :name="collapseId">
      <template slot="title">
         <img src="@/assets/icons/demography.svg">
         <span class="title">{{ languageIsEnglish ? "Fertility layers" : "प्रजनन्  सम्बन्धित तहहरु" }}</span>
         <input
            type="checkbox"
            class="check-all"
            v-model="optionSelected"
            @click="toggleAllLayer"
         >
      </template>
      <div v-for="group in layerGroups" :key="group.id" >
         <!-- <label :for="group.id">{{ languageIsEnglish ? group.title : group.titleNepali }}</label> -->
         <layer-radio-item
            :key="layer.id"
            v-for="layer in group.layers"
            :layer="layer"
            :opacity-slider="true"
            group-id="fertility-layers"
            :language-is-english="languageIsEnglish"
            v-on:show-legend="showLegend => layer.legendIsShown=showLegend"
            v-on:radio-select="selectData"
            v-on:change-opacity="changeOpacity"
         />
      </div>
   </collapse-item>
</template>

<script>
import { CollapseItem } from 'element-ui';
import LayerRadioItem from './LayerRadioItem';
// import { updateMunicipalityStyle } from '../../js/layers/index';
import { setFertilityOpacity, setFertilityLayersVisible, fertilityLayerGroupInfo,updateFertilityStyle } from '../../js/layers/fertility';
import { fetchAllDivisionData, setLastField } from '../../js/api';
import { bus } from '../../main';

export default {
   name: 'fertility-group',
   props: {
      languageIsEnglish: {type: Boolean, required: true},
      accordianParentId: {type: String},
   },
   components: {
      'layer-radio-item': LayerRadioItem,
      CollapseItem,
   },
   data()
   {
      return {
         layerGroups: fertilityLayerGroupInfo,
         currentLayerId: null,
         collapseId: 'fertility-group',
         optionSelected: true,
      };
   },
   mounted()
   {
      const layer = fertilityLayerGroupInfo[0].layers[2];
      this.selectData({layer, opacity:1});
      this.currentLayerId = layer.id;
   },
   methods: {
      async selectData({layer, opacity})
      {
         this.currentLayerId = layer.id;
         const allDivisionData = await fetchAllDivisionData(layer.field);
         setFertilityLayersVisible(true);
         setLastField(layer.field);
         this.optionSelected = true;
         updateFertilityStyle({...allDivisionData, colorMap: layer.colorMap});
         // updateMunicipalityStyle();
         setFertilityOpacity(opacity);
         // show only selected layers legend
         this.layerGroups.forEach(layerGroup => 
         {
            layerGroup.layers.forEach( lyr =>
            {
               lyr.legendIsShown = lyr.id===layer.id ? true : false;
            });
         });
         bus.$emit('label-title-change', {english: layer.titleEnglish, nepali: layer.titleNepali});
         bus.$emit('fertilty-layer-selected', layer);
      },
      toggleAllLayer(event)
      {
         event.stopPropagation();
         setFertilityLayersVisible(event.target.checked);
         // updateMunicipalityStyle();
      },
      changeOpacity({opacity, layer})
      {
         if (layer.id===this.currentLayerId)
         {
            setFertilityOpacity(opacity);
         }
      }
   }
}
</script>

<style lang="scss" scoped>
.title {
   font-family: "Montserrat", sans-serif;
   font-size: 15px;
   font-weight: 300;
   margin-left: 3px;
}

label, select {
   font-size: 13px;
}

label {
   font-weight: bold;
}

.check-all {
   position: absolute;
   right: 10px;
   top: 16px;
}
</style>